export enum ContentSpacePortalTableActionUiEnum {
  PUBLISH = 'PUBLISH',
  UNPUBLISH = 'UNPUBLISH',
  DELETE = 'DELETE',
}
